// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1PFkt","signatureButtonsRight":"ModalSign_signatureButtonsRight__2sp3R"};